import './header.scss';

function Header() {
   return (
      <header className = "header">
            <div className = "header__block-up">
               <div className = "header__wrapper">
                  <a href="https://www.reavon.com/"><img  className="pic_reavon" src= "/img/reavon.svg" alt= "JVC"></img></a>
                  <ul className="header_menu">
                     <li><a href="#UBR-X200">UBR-X200</a></li>
                     <li><a href="#UBR-X100">UBR-X100</a></li>
                  </ul>
                  <a href="https://www.pult.ru/"><img className="pic_logo" src= "/img/logo pult.svg" alt= ""></img></a>
               </div>
            </div>
            <div className = 'header_desc'>
               <img alt = "" src = "/img/header_desc.svg"></img>
               <p>Ваша коллеция фильмов заслуживает лучшее</p>
            </div>
            <div className='gradient'></div>
      </header>
   )
}
export default Header;